import React, { useEffect, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const QRCodeScanner = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Fetch geolocation data
  const fetchGeolocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          console.error("Geolocation error:", err);
          reject("Unable to fetch location. Please enable GPS.");
        }
      );
    });
  };

  // Handle QR Code Scan
  const handleQRScan = async (decodedText) => {
    setLoading(true);
    setError('');

    try {
      // Simulated student details
      const studentInfo = {
        student_id: "12345", // Replace with actual student ID
        student_name: "John Doe", // Replace with actual student name
        geolocation: await fetchGeolocation(), // Fetch geolocation
        qr_code_data: decodedText, // Scanned QR code data
      };

      // Send data to backend
      const response = await fetch('https://sams-backend-zs81.onrender.com/api/accounts/api/validate_attendance/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentInfo),
      });

      const result = await response.json();
      if (response.ok) {
        alert(result.message);
        if (result.status === "pending_face") {
          alert("Proceed with face detection.");
        }
      } else {
        setError(result.error || "Validation failed.");
      }
    } catch (err) {
      console.error("Error during validation:", err);
      setError("An error occurred. Please try again.");
    }

    setLoading(false);
  };

  useEffect(() => {
    const qrScanner = new Html5Qrcode("qr-reader");

    // Start QR Code Scanning
    qrScanner.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: { width: 250, height: 250 } },
      handleQRScan,
      (errorMessage) => {
        console.warn("QR Code scan error:", errorMessage);
      }
    );

    return () => {
      qrScanner.stop().catch(console.error);
    };
  }, []);

  return (
    <div className="scanner">
      <h1>Scan QR Code</h1>
      <div id="qr-reader"></div>
      {loading && <p>Validating...</p>}
      {error && <p className="error text-red-500">{error}</p>}
    </div>
  );
};

export default QRCodeScanner;
